import e from "@ui-components-3/ui/lib/components/Checkbox";

import o from "../createFormikField/index.js";

const t = o(e, (({value: e, ...o}) => ({
    checked: e,
    ...o
})), {
    labelPlacement: "right"
});

export { t as default };
//# sourceMappingURL=index.js.map
